export default "__VITE_ASSET__vd9IN6oD__"